<template>
  <div class="view">
    <Title title="メッセージ"/>
    <MessageEditMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import MessageEditMain from '@/components/Message/EditMain'

export default {
  components: {
    Title,
    MessageEditMain
  }
}
</script>
